import React from "react";
import classnames from "classnames";

import { PromotedStrain } from "custom-types/Directus";

import CoinList from "components/CoinList";
import PhenotypeCarousel from "components/PhenotypeCarousel";
import StrainCarousel from "components/StrainCarousel";

type Props = {
  categories: string[];
  className?: string;
  isLoading?: boolean;
  promotedStrains: PromotedStrain[];
};

const DealTypeCarousels: React.FC<Props> = ({
  categories,
  className,
  isLoading,
  promotedStrains,
}) => {
  return (
    <div className={classnames(className)}>
      <h3 className="heading--l mb-lg">Shop deals your way</h3>
      <CoinList
        isLoading={isLoading}
        coins={categories}
        title="420 deals by product"
        className="mt-xl"
        hrefLinkQueryParam={"&deal_active=true"}
        hrefLink={"/search/shop"}
        hrefProductCatQueryKey={"product_category"}
      />
      <h3 className="heading--m font-bold mt-xl mb-sm">
        Deals on weed by strain type
      </h3>
      <PhenotypeCarousel asLink linkToDeals />

      {promotedStrains && (
        <StrainCarousel
          promotedStrains={promotedStrains}
          title="Deals on top weed strains near you"
          asLink
          linkToDeals
          className="mt-xl"
        />
      )}
    </div>
  );
};

export default DealTypeCarousels;
